import React from 'react';
import '../styles/programs.css';
import callforstartup from './ProgramImages/Call.jpg';
import img1 from './ProgramImages/10.png';
import img2 from './ProgramImages/2.png';
import img3 from './ProgramImages/3.png';
import droneImg from './ProgramImages/1.png';

const programData = [
  {
    id: 1,
    title: 'Call For Startup Incubation at IIT ROPAR - TBIF',
    description:
      'Are you innovative entrepreneurs of a startup with a ground-breaking idea? TBIF? Apply now to get incubated at IIT Ropar - TBIF and get access to a wide range of resources and mentorship. Apply by 15th September 2024.',
    link: 'https://wadhwanifoundation.org/liftoff-batches/',
    imageUrl: callforstartup,
  },
  {
    id: 2,
    title: 'Entrepreneurship Orientation Program',
    description:
      'TBIF, in collaboration with Startup Punjab (GoP), has organized the "Entrepreneurship Orientation Program" specifically tailored for aspiring student entrepreneurs at Indian Institute of Technology, Ropar. The program comprised five interactive sessions held on various dates from 29th February to 28th March 2024.',
    link: 'https://www.iitrpr.ac.in/',
    imageUrl: img1,
  },
  {
    id: 3,
    title: "Cybersecurity Course for Armed Forces",
    description:
      'The Centre of Excellence for Studies and Applied Research in Defence and Security at IIT Ropar, in collaboration with the Directorate General Resettlement (DGR), organized a pioneering course on Cybersecurity for the armed forces.',
    link: 'https://www.iitrpr.ac.in/',
    imageUrl: img2,
  },
  {
    id: 4,
    title:
      'DGCA Authorized Remote Pilot Training Organization and Establishment of CoE with MP Govt.',
    description:
      'Synergy in Research, Development, and Innovation for Modernization of the Military.',
    link: 'https://www.iitrpr.ac.in/',
    imageUrl: droneImg,
  },
];

function Programs() {
  return (
    <div className="flex pb-28 flex-col items-center pt-20 px-8 border-b border-gray-500 bg-gradient-to-br from-white">
      <h2 className="text-4xl sm:text-5xl font-bold text-center text-black mb-8">
        <span className="text-blue-500">P</span>rograms
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full max-w-7xl">
        {programData.map((program) => (
          <div
            key={program.id}
            className="bg-zinc-900 lg:h-[450px] overflow-auto rounded-2xl px-2 py-3  shadow-lg flex flex-col"
          >
            <a href={program.link} className="block">
              <div className="w-full aspect-w-16 aspect-h-9">
                <img
                  src={program.imageUrl}
                  alt={program.title}
                  className="w-full rounded-2xl h-full object-cover transition-transform duration-300 hover:scale-105"
                />
              </div>
            </a>
            <div className="p-4 flex-1 flex flex-col">
              <h3 className="text-xl font-semibold text-white mb-2">
                <a href={program.link}>{program.title}</a>
              </h3>
              <p className="text-gray-300 flex-1 mb-4">
                {program.description}
              </p>
              <div className="mt-auto text-center">
                <a href={program.link}>
                  <button className="bg-blue-700 hover:bg-blue-600 text-white font-medium px-4 py-2 rounded-lg transition-colors">
                    Read More
                  </button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Programs;
